import { useState } from 'react'

import { Autoplay, Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import Banner01 from 'assets/jpg/home/banner_01.png'
import Banner02 from 'assets/jpg/home/banner_02.png'
import Banner03 from 'assets/jpg/home/banner_03.png'
import Banner04 from 'assets/jpg/home/banner_04.png'
import Banner05 from 'assets/jpg/home/banner_05.png'
import Banner06 from 'assets/jpg/home/banner_06.png'
import Banner07 from 'assets/jpg/home/banner_07.png'
import BannerAlavancas from 'assets/jpg/home/banner_alavancas.png'
import BannerChampions from 'assets/jpg/home/banner_champions.png'
import BannerFechamento from 'assets/jpg/home/banner_fechamento.png'

import * as S from './styles'

type Slide = {
  logo?: React.ReactElement
  title: string
  description: string
  image: string
  objectFit?: 'cover' | 'contain' | 'fill'
  cta?: string
  link?: string
}

export const Gallery = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [infoOpacity, setInfoOpacity] = useState(1)

  const handleTransparent = () => {
    if (slides.length > 1) setInfoOpacity(0)
  }

  const handleLink = (link?: string) => {
    if (link) window.open(link, '_blank')
  }

  const slides: Slide[] = [
    {
      description: '',
      image: BannerAlavancas,
      link: 'https://alpargatascombr.sharepoint.com/sites/Planejamento-Operacao-Comercial/Documentos/Forms/AllItems.aspx?id=%2fsites%2fPlanejamento-Operacao-Comercial%2fDocumentos%2f18%20Analises%20Pontuais%2fLunita%20-%20Lamina.pdf&parent=%2fsites%2fPlanejamento-Operacao-Comercial%2fDocumentos%2f18%20Analises%20Pontuais&p=true&ct=1786104623515&or=OWA-NT-Mail&cid=0036a245-c26e-11a6-62e4-328832c53a91&ga=1',
      objectFit: 'fill',
      title: '',
    },
    {
      description: '',
      image: BannerFechamento,
      link: 'https://alpargatascombr.sharepoint.com/sites/GTMBrasil/Documentos%20Compartilhados/Forms/AllItems.aspx?id=%2fsites%2fGTMBrasil%2fDocumentos%20Compartilhados%2f01%20GTM%2f11%20RVV%20%26%20Campanhas%2fCampanhas%20Comerciais%2f2026.09%20-%20Antecipa%C3%A7%C3%A3o%20Carteira%2fCampanha%20de%20Fechamento%20do%20Ano%20dos%20ORIGINAIS.pdf&parent=%2fsites%2fGTMBrasil%2fDocumentos%20Compartilhados%2f01%20GTM%2f11%20RVV%20%26%20Campanhas%2fCampanhas%20Comerciais%2f2026.09%20-%20Antecipa%C3%A7%C3%A3o%20Carteira&p=true&ct=1785788214731&or=OWA-NT-Mail&cid=687c03e0-8abe-48a6-b31c-4d3dde6b1f32&ga=1',
      objectFit: 'fill',
      title: '',
    },
    {
      description: '',
      image: BannerChampions,
      link: 'https://alpargatascombr.sharepoint.com/sites/GTMBrasil/Documentos%20Compartilhados/Forms/AllItems.aspx?id=%2fsites%2fGTMBrasil%2fDocumentos%20Compartilhados%2f01%20GTM%2f11%20RVV%20%26%20Campanhas%2fCampanhas%20Comerciais%2f2026.05%20-%20Champions%202027%2fCampanha%2026-27_Champions_Pasta%20Comercial%2fRegulamento%20-%20Campanha%2026-26%20-%20Champions.pdf&parent=%2fsites%2fGTMBrasil%2fDocumentos%20Compartilhados%2f01%20GTM%2f11%20RVV%20%26%20Campanhas%2fCampanhas%20Comerciais%2f2026.05%20-%20Champions%202027%2fCampanha%2026-27_Champions_Pasta%20Comercial&p=true&ct=1781018626093&or=OWA-NT-Mail&cid=f0457c44-7a35-83ab-4877-d350c82624e3&ga=1',
      objectFit: 'fill',
      title: '',
    },
    {
      description: '',
      image: Banner02,
      title: 'E a Coleção 26-27\njá é campeã.',
    },
    {
      description: 'Foco nas tiras grossas.',
      image: Banner07,
      title: 'OS HOMENS QUEREM CONFORTO. E AGORA NÃO NOS FALTA CAPACIDADE DE ATENDER.',
    },
    {
      description: '',
      image: Banner01,
      objectFit: 'fill',
      title: '',
    },
    {
      description: '',
      image: Banner06,
      title: 'FOCO TOTAL NA DISTRIBUIÇÃO DE FANTASIA, TIRA GROSSA E BABY',
    },
    {
      description:
        'Garanta que seus clientes estejam abastecidos dos modelos obrigatórios de cada canal',
      image: Banner03,
      link: `${process.env.REACT_APP_DOWNLOAD_FILES_BASE_URL}/modelos_obrigatorios.xlsx`,
      title: 'Não esquecer dos modelos obrigatórios!',
    },
    {
      description: 'Clique aqui e acesse agora mesmo.',
      image: Banner04,
      link: 'https://alu.sa.crossknowledge.com/site/path/1550',
      title: 'As pílulas sobre o Portal já estão disponíveis no Sales Academy!',
    },
    {
      description: 'Clique aqui e descubra como a nova ferramenta de metas irá funcionar.',
      image: Banner05,
      link: `${process.env.REACT_APP_DOWNLOAD_FILES_BASE_URL}/guia_de_uso_12_11.pdf`,
      title: 'Nova ferramenta de metas!',
    },
  ]

  return (
    <S.Wrapper>
      <S.SwiperPanel hasLink={!!slides[currentSlide].link}>
        <S.InfoContainer opacity={infoOpacity}>
          {slides[currentSlide].logo && <>{slides[currentSlide].logo}</>}
          <S.InfoTitle>{slides[currentSlide].title}</S.InfoTitle>
          {slides[currentSlide].description && (
            <S.InfoDescription>{slides[currentSlide].description}</S.InfoDescription>
          )}
          {slides[currentSlide].cta && <S.InfoBullet>{slides[currentSlide].cta}</S.InfoBullet>}
        </S.InfoContainer>
        <Swiper
          autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }}
          height={256}
          loop={slides.length > 1}
          modules={[Pagination, Autoplay, Navigation]}
          navigation
          onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
          onTouchEnd={() => setInfoOpacity(1)}
          onTouchMove={handleTransparent}
          pagination={{ clickable: true, type: 'bullets' }}
          slidesPerView={1}
        >
          {slides.map((slide, index) => {
            return (
              <SwiperSlide key={`slide-${index}`} onClick={() => handleLink(slide.link)}>
                <S.SwiperImage objectFit={slide.objectFit} src={slide.image} />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </S.SwiperPanel>
    </S.Wrapper>
  )
}
